import React from "react";
import Icon from "components/Varios/Icons.js";
import CreatableSelect from 'react-select/creatable';

import TooltipItem from "components/Varios/Tooltip.js";

export default class SelectCreate extends React.Component {

    customStyles = {
        container: (provided, state) => ({
            ...provided,
            height: "27px",
            position: "relative",
            flex: "1 1 auto",
            width: "1%",
            minWidth: "0",
            marginBottom: "0",
        }),
        indicatorContainer: (provided) => ({
            ...provided,
            width: "0%",
            display: "none"
        }),
        control: (provided, state) => {
            const backgroundColor = state.isDisabled ? "#E3E3E3" : "#fff";
            return {
                ...provided,
                borderRadius: "0px",
                border: "1px solid #E3E3E3",
                backgroundColor: "transparent",
                color: "#2c2c2c",
                lineHeight: "normal",
                minHeight: "27px",
                height: "27px",
                fontSize: "0.8571em",
                boxShadow: "none",
                width: "auto",
                fontFamily: "Montserrat",
                backgroundColor
            }
        },
        menu: (provided, state) => ({
            ...provided,
            fontSize: "0.8em",
            minWidth: "150px",
            zIndex: "100"
        }),
    }

    state = {
        selectedValue: this.props.value,
    };

    handleChange = selectedValue => {
        this.setState(
            { selectedValue },
            (() => { selectedValue != null ? this.props.onChange(selectedValue.value, this.props.name, this.props.tipo, selectedValue.label) : this.props.onChange(0, this.props.name, this.props.tipo, '') })
        );
    };

    render() {
        return (
            <div className="input-group">
                <CreatableSelect
                    isClearable
                    options={this.props.options}
                    value={(this.props.value !== null && this.props.value !== -1 ? this.props.options.find(obj => obj.value === this.props.value) : null)}
                    onChange={this.handleChange}
                    styles={this.customStyles}
                    placeholder={this.props.placeholder}
                    name={this.props.name}
                    id={this.props.id}
                    isDisabled={(this.props.disabled)}
                    isRequired={true}
                />
                <div className="input-group-append" style={{ backgroundColor: "#FFC200" }}>
                    {this.props.icon.startsWith("fa-") ? (<i className={"fas " + this.props.icon} aria-hidden="true"></i>) : (<Icon kind={this.props.icon} fill='#FFFFFF' width={27} height={27} />)}

                </div>
                <TooltipItem content={this.props.placeholder} id={this.props.id} />
            </div>
        )

    }
}